import { Flex } from '@mantine/core';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import MeetingContact from 'components/shared/Meeting/MeetingList/MeetingCard/MeetingContact';
import FieldSelect from 'components/shared/form/FieldSelect';
import Loader from 'components/ui/Loader';
import { useCreateMeetingDrawerModal } from 'stores/global/CreateMeetingDrawerModal';
import { createFullName } from 'utils/createFullName';

import Detail from '../Detail';
import SubAgentSelect from '../SubAgentSelect';

import s from './CreateWithClient.module.scss';

const CreateWithClient: React.FC = () => {
  const createMeetingDrawerModal = useCreateMeetingDrawerModal();
  const {
    leadSelectStore,
    hasLeadOptions,
    clientValue,
    clientLoadingStage,
    createLoadingStage,
    projectTimeSlot,
    clientUniquenessStore,
  } = createMeetingDrawerModal;

  if (!clientValue.value) {
    return null;
  }

  if (clientLoadingStage.isLoading) {
    return (
      <Flex justify="center" align="center" h="100%">
        <Loader />
      </Flex>
    );
  }

  return (
    <Flex direction="column" gap="xl" w="100%" h="100%">
      <Flex p="md" className={s.root__drawer}>
        <MeetingContact title="Клиент" fullName={createFullName(clientValue.value)} phone={clientValue.value.phone} />
      </Flex>

      <SubAgentSelect />

      {clientUniquenessStore.shouldCheckUniqueByPhoneAndProject && (
        <FieldSelect
          fw="600"
          label="Проект"
          placeholder="Выберите проект"
          store={projectTimeSlot.projects}
          disabled={createLoadingStage.isLoading}
        />
      )}

      {leadSelectStore.shown && (
        <FieldSelect
          fw="600"
          label="Заявка"
          placeholder={hasLeadOptions ? 'Выберите заявку' : 'Заявок нет'}
          store={leadSelectStore}
          disabled={createLoadingStage.isLoading || !hasLeadOptions}
        />
      )}

      {(!leadSelectStore.shown || leadSelectStore.value.length > 0) && <Detail />}
    </Flex>
  );
};

export default observer(CreateWithClient);
